const generateFullPath = (relativePath) => {
  return process.env.VUE_APP_BASE_URL + relativePath;
};

const generateLink = (id) => {
  const newID = id.replaceAll("/", "%2F");
  const baseLink = process.env.VUE_APP_BASE_URL + "/cms#/";

  if (id.split("/").includes("articles")) {
    return baseLink + `articles/details/${newID}`;
  } else if (id.link) {
    return baseLink + `videos/${newID}`;
  } else {
    return baseLink + `news/details/${newID}`;
  }
};

export { generateFullPath, generateLink };
